import { Box } from '@factorialco/deprecated-design-system'

import { Panes } from 'modules/core/components/Panes'

import { DeprecationCallout } from 'modules/competencies/components/DeprecationCallout'
import { NineGridBoxProvider } from 'modules/competencies/lib/ninegridboxContext'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import NineForm from './Form'
import Report from './Report'

const NineBox = () => {
  return (
    <ResponsivePage.NestedBody>
      <DeprecationCallout />

      <Box justifyContent="center" maxWidth="full">
        <NineGridBoxProvider>
          <Panes direction="horizontal-2-cols-fixed-left">
            <NineForm />
            <Report />
          </Panes>
        </NineGridBoxProvider>
      </Box>
    </ResponsivePage.NestedBody>
  )
}

export default NineBox
